import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type SharedAnswers = Record<string, string>;

type SharedAssujettiAnswersContextValue = {
  sharedAnswers: SharedAnswers;
  publishSharedAnswer: (
    key: string,
    label: string,
    overwrite?: boolean
  ) => void;
};

const SharedAssujettiAnswersContext =
  createContext<SharedAssujettiAnswersContextValue | null>(null);

export function SharedAssujettiAnswersProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [sharedAnswers, setSharedAnswers] = useState<SharedAnswers>({});

  const publishSharedAnswer = useCallback(
    (key: string, label: string, overwrite = false) => {
      if (!label) return;
      setSharedAnswers((prev) => {
        if (!overwrite && prev[key] !== undefined) return prev;
        if (prev[key] === label) return prev;
        return { ...prev, [key]: label };
      });
    },
    []
  );

  const value = useMemo(
    () => ({ sharedAnswers, publishSharedAnswer }),
    [sharedAnswers, publishSharedAnswer]
  );

  return (
    <SharedAssujettiAnswersContext.Provider value={value}>
      {children}
    </SharedAssujettiAnswersContext.Provider>
  );
}

export function useSharedAssujettiAnswers() {
  return useContext(SharedAssujettiAnswersContext);
}
